// Sequence icon — a stack of three offset rectangles suggesting a grouped
// list of children that run together. Intentionally clean so it reads as
// "wrapper / container" rather than another data glyph.
export default function SequenceIcon({ size = 14, color = "currentColor", className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke={color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <rect x="2" y="3" width="10" height="2.5" rx="0.6" />
      <rect x="3" y="6.75" width="10" height="2.5" rx="0.6" />
      <rect x="4" y="10.5" width="10" height="2.5" rx="0.6" />
    </svg>
  );
}
